import request from './request';

import { CHANNEL_ID } from '../../constants/channels';
import { ENDPOINT } from '../../constants/api';

export default {
  generateAltText({ image, signal, v2, shopId, channel, db }) {
    return request.post({
      endpoint: ENDPOINT.WEB_V2,
      payload: { image, shop_id: shopId, channel_id: CHANNEL_ID[channel], db },
      signal,
      url: v2
        ? '/ai/v2/generate-alt-text'
        : '/ai/generate-alt-text',
    });
  },
  generateText({ channel, destination, input, operation, signal, v2, shopId, db }) {
    return request.post({
      endpoint: ENDPOINT.WEB_V2,
      payload: {
        channel,
        destination_field: destination,
        input,
        operation,
        shop_id: shopId,
        db,
      },
      signal,
      url: v2
        ? '/ai/v2/product-field-text-generator'
        : '/ai/product-field-text-generator', // TODO: delete with FEATURE_FLAG_AI_V2
    });
  },
};
